import { render, staticRenderFns } from "./PlayerAudio.vue?vue&type=template&id=3d8a62c4"
import script from "./PlayerAudio.vue?vue&type=script&lang=ts"
export * from "./PlayerAudio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports